import axios from '../axios';

export default {
  getDoorOpeningMobiles (options) {
    const params = {};
    if (options.filters && Object.keys(options.filters).length) {
      for (const filterName in options.filters) {
        params[`filter[${filterName}]`] = options.filters[filterName];
      }
    }

    if (options.pagination) {
      params.pagination = 1;
    }

    if (options.include) {
      params.include = options.include;
    }

    if (options.page) {
      params.page = options.page;
    }

    if (options.limit) {
      params.limit = options.limit;
    }

    const query = [];
    for (const param in params) {
      query.push(encodeURIComponent(param) + '=' + encodeURIComponent(params[param]));
    }

    return new Promise((resolve, reject) => {
      axios.get('/door-opening?' + query.join('&'))
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  getBarrierOpeningMobiles (options) {
    const params = {};
    if (options.filters && Object.keys(options.filters).length) {
      for (const filterName in options.filters) {
        params[`filter[${filterName}]`] = options.filters[filterName];
      }
    }

    if (options.pagination) {
      params.pagination = 1;
    }

    if (options.include) {
      params.include = options.include;
    }

    if (options.page) {
      params.page = options.page;
    }

    if (options.limit) {
      params.limit = options.limit;
    }

    const query = [];
    for (const param in params) {
      query.push(encodeURIComponent(param) + '=' + encodeURIComponent(params[param]));
    }

    return new Promise((resolve, reject) => {
      axios.get('/barrier-opening?' + query.join('&'))
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },

  getDoorOpeningMobile (id) {
    return new Promise((resolve, reject) => {
      axios.get(`/door-opening/${id}`)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
};
